import Mock from "mockjs";
import CommonResultFactory from "./common-result";
const Random = Mock.Random;

const dataMap = {
  "cer-ratings-platform": {
    platforms: ["C", "A", "R", "E", "S"],
    data: [
      {
        name: "A",
        data: [
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100)
        ]
      },
      {
        name: "B",
        data: [
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100)
        ]
      },
      {
        name: "C",
        data: [
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100)
        ]
      },
      {
        name: "F",
        data: [
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100)
        ]
      },
      {
        name: "FSF",
        data: [
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100),
          Random.integer(0, 100)
        ]
      }
    ]
  },
  "most-recent-cer-average": {
    cerAvgRating: "D",
    cerAvgScore: 60.3,
    cerTotalCount: 310
  },
  "most-recent-cer-by-ratings": [
    {
      rating: "A",
      ratingPercent: 0,
      ratingColor: ""
    },
    {
      rating: "B",
      ratingPercent: 5,
      ratingColor: ""
    },
    {
      rating: "C",
      ratingPercent: 28,
      ratingColor: ""
    },
    {
      rating: "D",
      ratingPercent: 22,
      ratingColor: ""
    },
    {
      rating: "F",
      ratingPercent: 1,
      ratingColor: ""
    },
    {
      rating: "FSF",
      ratingPercent: 4,
      ratingColor: ""
    }
  ],
  "food-safety-by-rating": {
    avgRatingCount: 5.5,
    ratings: [
      {
        rating: "B",
        ratingCount: 1,
        ratingColor: "G"
      },
      {
        rating: "C",
        ratingCount: 2.7,
        ratingColor: "Y"
      },
      {
        rating: "D",
        ratingCount: 3.8,
        ratingColor: "R"
      },
      {
        rating: "F",
        ratingCount: 5,
        ratingColor: "R"
      },
      {
        rating: "FSF",
        ratingCount: 7,
        ratingColor: "R"
      }
    ]
  },
  "highest-impact-opportunities": {
    itemIds: ["01", "02", "03", "04", "05"],
    opportunities: [
      "Potentially hazardous products are within food safety temp standards (FS-Critical)",
      "BOH",
      "PPH",
      "MPA",
      "SIP"
    ].reverse(),
    values: [90, 82, 76, 66, 55].reverse(), // -> 与 opportunities 对应
    misses: [
      {
        name: "B",
        values: [40, 27, 47, 20, 27].reverse() // -> 与 opportunities 对应
      },

      {
        name: "F",
        values: [90, 80, 95, 100, 88].reverse() // -> 与 opportunities 对应
      }
    ]
  },
  "most-recent-cer-sos": [
    {
      type: "Q Time",
      avgTime: 6
    },
    {
      type: "T Time",
      avgTime: 75
    },
    {
      type: "W Time",
      avgTime: 422
    },
    {
      type: "TT Time",
      avgTime: 497
    }
  ],
  "overall-academy-engagement": {
    totalActiveCount: 199,
    activePercent: 60.3,
    totalRestCount: 310,
    arrowStatus: 0
  },
  "academy-engagement-by-region": {
    activePercent: 25.5,
    totalActiveCount: 85,
    totalRestCount: 313,
    regions: [
      {
        region: "Eastern",
        regionActiveCount: 47,
        regionPercent: 32.6,
        totalRestCount: 306,
        totalActiveCount: 144,
        activePercent: 47.1
      },
      {
        region: "FRANCHISE",
        regionActiveCount: 20,
        regionPercent: 14.1,
        totalRestCount: 306,
        totalActiveCount: 144,
        activePercent: 47.1
      },
      {
        region: "Riyadh",
        regionActiveCount: 44,
        regionPercent: 30.6,
        totalRestCount: 306,
        totalActiveCount: 144,
        activePercent: 47.1
      },
      {
        region: "Riyadh-Central",
        regionActiveCount: 1,
        regionPercent: 0.7,
        totalRestCount: 306,
        totalActiveCount: 144,
        activePercent: 47.1
      },
      {
        region: "Western",
        regionActiveCount: 36,
        regionPercent: 25,
        totalRestCount: 306,
        totalActiveCount: 144,
        activePercent: 47.1
      }
    ]
  },
  "academy-patterns-by-category": {
    categories: [
      {
        category: "Story",
        categoryId: "CT0000001",
        achievePercent: 80
      },
      {
        category: "Essentials",
        categoryId: "CT0000004",
        achievePercent: 50
      },
      {
        category: "Food",
        categoryId: "CT0000002",
        achievePercent: 40
      },
      {
        category: "Service",
        categoryId: "CT0000003",
        achievePercent: 35
      },
      {
        category: "Certs",
        categoryId: "CT0000006",
        achievePercent: 44
      }
    ]
  },
  "our-daily-routines-engagement-avg": {
    totalActiveCount: 225,
    activePercent: 72.5,
    totalRestCount: 310,
    arrowStatus: 1
  },
  "overall-academy-avg-skill-quotient": {
    date: ["2018-01-01", "2018-02-01", "2018-03-01", "2018-04-01"],
    labels: ["Jan", "Feb", "Mar", "Apr"],
    data: [
      {
        name: "average",
        data: [15, 18, 23, 29] // -> ['2018-01-01', '2018-02-01', '2018-03-01', '2018-04-01']
      },
      {
        name: "bottom",
        data: [9, 12, 17, 20]
      },
      {
        name: "top",
        data: [30, 35, 40, 45]
      }
    ]
  },
  "projected-versus-reported-sales": {
    totalProjectedSales: 28500,
    totalReportedSales: 45714,
    versusPercent: 63.8,
    arrowStatus: 1
  },
  "most-recent-cer-and-academy": {
    ratings: ["B", "C", "D", "F", "FS Fail"],
    data: [
      {
        label: "MR CER",
        data: [93.14, 85.34, 76.48, 66.75, 52.84]
      },
      {
        label: "Academy SQ",
        data: [24.37, 21.37, 19.99, 17.52, 15.17]
      }
    ]
  },
  "leader-daily-visit-engagement": {
    totalCount: 32,
    totalActiveCount: 5,
    activePercent: 15.6,
    arrowStatus: -1
  },
  "kpi-alerts-triggered-and-actioned": {
    totalCount: 0,
    totalActiveCount: 0,
    activePercent: 0,
    arrowStatus: 0
  },
  "our-routines-complete-by-kpi": {
    ratings: ["FS", "QC", "F8", "CO", "DT"],
    data: [
      {
        label: "All",
        data: [93.14, 85.34, 76.48, 66.75, 52.84]
      },
      {
        label: "Top 25",
        data: [24.37, 21.37, 19.99, 17.52, 15.17]
      },
      {
        label: "Bottom 25",
        data: [24.37, 21.37, 19.99, 17.52, 15.17]
      }
    ]
  },
  "our-routines-patterns-by-daypart": [
    {
      daypart: "BR",
      sales: 5615
    },
    {
      daypart: "LU",
      sales: 5824
    },
    {
      daypart: "SN",
      sales: 4763
    },
    {
      daypart: "DN",
      sales: 10199
    }
    ,
    {
      daypart: "LN",
      sales: 2099
    }
  ],
  "routine-complete-by-status": [
    {
      time: "6:00 AM",
      sales: 5615,
      percent: 63,
      status: "0/8"
    },
    {
      time: "6:30 AM",
      sales: 5824,
      percent: 65,
      status: "3/17"
    },
    {
      time: "1:00 PM",
      sales: 4763,
      percent: 60,
      status: "1/15"
    },
    {
      time: "4:30 PM",
      sales: 10199,
      percent: 30,
      status: "2/15"
    }
  ],
  "our-routines-complete-by-am": {
    // date: ["2018-01-01", "2018-02-01", "2018-03-01", "2018-04-01"],
    type: [
      "AM1",
      "AM2",
      "AM3",
      "AM4",
      "AM5",
      "AM6",
      "AM7",
      "AM8",
      "AM9",
      "AM10",
      "AM11",
      "AM12"
    ],
    sales: [
      25864,
      12589,
      15347,
      45692,
      12369,
      45896,
      47852,
      69547,
      12589,
      45826,
      45963
    ],
    data: [
      {
        name: "Top",
        data: [90, 95, 80, 70, 77, 83, 88, 72, 90, 91, 90, 88],
        sales: [
          54714,
          52369,
          47852,
          45692,
          12369,
          45896,
          47852,
          69547,
          12589,
          45826,
          45963
        ]
      },
      {
        name: "All",
        data: [70, 66, 55, 67, 66, 66, 77, 54, 55, 76, 69, 56],
        sales: [
          25864,
          12589,
          15347,
          45692,
          12369,
          45896,
          47852,
          69547,
          12589,
          45826,
          45963
        ]
      },
      {
        name: "Bottom",
        data: [30, 35, 40, 45, 55, 27, 34, 33, 41, 23, 35, 36],
        sales: [
          54714,
          52369,
          47852,
          45692,
          12369,
          45896,
          61478,
          55748,
          85463,
          47528,
          25896
        ]
      }
    ]
  },
  "routines-by-cer-rating-average-complete-routines": {
    ratings: ["FS", "QC", "F8", "CO", "DT"],
    data: [
      {
        label: "All Avg",
        data: [6, 5.5, 5.7, 5.3, 4.7]
      },
      {
        label: "B Avg",
        data: [4.9, 5.3, 4.7, 4, 3.2]
      },
      {
        label: "F Avg",
        data: [3.1, 3.5, 3.3, 2.8, 2.2]
      }
    ]
  }
};

export default req => {
  let url = req.url,
    data;
  //Just Overall
  if (url.indexOf("projected-versus-reported-sales") >= 0)
    data = dataMap["projected-versus-reported-sales"];
  else if (url.indexOf("most-recent-cer-and-academy") >= 0)
    data = dataMap["most-recent-cer-and-academy"];
  else if (url.indexOf("leader-daily-visit-engagement") >= 0)
    data = dataMap["leader-daily-visit-engagement"];
  else if (url.indexOf("kpi-alerts-triggered-and-actioned") >= 0)
    data = dataMap["kpi-alerts-triggered-and-actioned"];
  else if (url.indexOf("rm-reported-and-actioned") >= 0)
    data = dataMap["leader-daily-visit-engagement"];
  else if (url.indexOf("before-and-after-follow-up-photos") >= 0)
    data = dataMap["leader-daily-visit-engagement"];
  else if (url.indexOf("our-routines-complete-by-am") >= 0)
    data = dataMap["our-routines-complete-by-am"];
  else if (url.indexOf("our-academy-sq-by-am") >= 0)
    data = dataMap["our-routines-complete-by-am"];
  else if (url.indexOf("our-most-recent-cer-by-am") >= 0)
    data = dataMap["our-routines-complete-by-am"];
  else if (url.indexOf("routines-by-cer-rating-average-complete-routines") >= 0)
    data = dataMap["routines-by-cer-rating-average-complete-routines"];
  // cer
  else if (url.indexOf("cer-ratings-platform") >= 0)
    data = dataMap["cer-ratings-platform"];
  else if (url.indexOf("most-recent-cer-average") >= 0)
    data = dataMap["most-recent-cer-average"];
  else if (url.indexOf("most-recent-cer-by-ratings") >= 0)
    data = dataMap["most-recent-cer-by-ratings"];
  else if (url.indexOf("food-safety-by-rating") >= 0)
    data = dataMap["food-safety-by-rating"];
  else if (url.indexOf("cer-fuv-visits-by-leader") >= 0)
    data = dataMap["food-safety-by-rating"];
  else if (url.indexOf("highest-impact-opportunities") >= 0)
    data = dataMap["highest-impact-opportunities"];
  else if (url.indexOf("food-safety-most-missed") >= 0)
    data = dataMap["highest-impact-opportunities"];
  else if (url.indexOf("most-recent-cer-sos") >= 0)
    data = dataMap["most-recent-cer-sos"];
  // academy
  else if (url.indexOf("overall-academy-engagement") >= 0)
    data = dataMap["overall-academy-engagement"];
  else if (url.indexOf("overall-academy-avg-skill-quotient") >= 0)
    data = dataMap["overall-academy-avg-skill-quotient"];
  else if (url.indexOf("academy-engagement-by-region") >= 0)
    data = dataMap["academy-engagement-by-region"];
  else if (url.indexOf("academy-patterns-by-category") >= 0)
    data = dataMap["academy-patterns-by-category"];
  // routines
  else if (url.indexOf("our-daily-routines-engagement-avg") >= 0)
    data = dataMap["our-daily-routines-engagement-avg"];
  else if (url.indexOf("our-routines-complete-by-kpi") >= 0)
    data = dataMap["our-routines-complete-by-kpi"];
  else if (url.indexOf("our-routines-patterns-by-daypart") >= 0)
    data = dataMap["our-routines-patterns-by-daypart"];
  else if (url.indexOf("our-routines-engagement-by-region") >= 0)
    data = dataMap["academy-engagement-by-region"];
  else if (url.indexOf("routine-complete-by-opening-checklist") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-closing-checklist") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-produce-cook-outs") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-quality-check") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-boh-travel-path") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-foh-travel-path") >= 0)
    data = dataMap["routine-complete-by-status"];
  else if (url.indexOf("routine-complete-by-full-travel-path") >= 0)
    data = dataMap["routine-complete-by-status"];

  return CommonResultFactory.success(data);
};



// WEBPACK FOOTER //
// ./src/mock/chart-data.js